var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",class:{
    'button--small': _vm.small,
    'button--active': _vm.active,
    'button--icon': _vm.icon,
  },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handleOnClick}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }